import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  heading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  value: {
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.textField.dark,
  },
  firstInnerDiv: {
    width: '100%',
  },
  tableGridComponent: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: 4,
    display: 'inline-flex',
    padding: theme.spacing(0, 4),
  },
  gridDiv: {
    paddingTop: '16px',
    paddingBottom: '40px',
  },
}))
